import ab from './ab.json';
import en from './en.json';


export const dictionaryList = { en, ab };
export const languageOptions = {
  en: 'English',
  ab: 'Arabic'
};